import React, { FC } from 'react';

interface Props {
  /** Padding/height override — a slider needs far less vertical space than a full PLP grid. */
  className?: string;
}

/**
 * The single "we could not load products" message, shared by every server-path listing surface: the V2
 * product-listing section and the V2 product slider and grid.
 *
 * Callers are expected to render this INSIDE their own section shell, keeping the heading visible — a
 * bare message with no heading gives the visitor no idea which part of the page failed.
 */
const ProductsLoadError: FC<Props> = ({ className = 'min-h-[40vh] px-24 py-60 pb-[50px]' }) => (
  <div className={`flex items-center justify-center text-center ${className}`}>
    <p className="text-22 text-[#AE1D32] 2xl:text-26">
      Error loading products. Please refresh the page or try again later.
    </p>
  </div>
);

export default ProductsLoadError;
